import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// The same guard as the società's kits page: the role lets in, and whether these kits are the
// caller's the page asks (`canEditRoster`) and the API answers. Under the root, as that one is.
export const teamKitsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/teams/$teamId/kits',
  params: numericIdParam('teamId'),
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club', 'coach'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/team-kits.tsx')),
})

/** The way in from the squad's page, the coach's profile and the società's kits. */
export function teamKitsLink(teamId: number) {
  return { to: '/teams/$teamId/kits', params: { teamId } } as const
}
